import { useEffect, useState } from 'react';
import { useForm } from 'react-hook-form';
import useFetch from '../../../../hooks/useFetch';
import { useGetAdherent } from '../../../../hooks/useGetAdherent';
import { DemandeContact } from '../../../../services/Api/swagger';
import { ContactFormData } from './helpers';
import { isAuthenticated } from '../../../../services/Authentification/authentification';
import { OptionType } from 'bc-front-sagacomponents/lib/src/components/Inputs/Select';

export const useContactForm = () => {
  const { listeAdherents, listeAdhesions } = useGetAdherent();
  const authenticated = isAuthenticated();

  // ------------
  // INIT FORMULAIRE
  // ------------
  const methods = useForm<ContactFormData>({
    mode: 'onBlur',
    reValidateMode: 'onBlur',
    criteriaMode: 'all',
    defaultValues: {
      nom: listeAdherents && listeAdherents[0] && listeAdherents[0].nom + ' ' + (listeAdherents[0].prenom || ' '),
      email: listeAdherents && listeAdherents[0] && listeAdherents[0].email,
      telephone: listeAdherents && listeAdherents[0] && listeAdherents[0].telephone,
    },
  });

  // const [immatOptionsList, setImmatOptionsList] = useState<OptionType[]>();
  let immatOptionsList: OptionType[] | undefined;
  if (listeAdhesions) {
    // On peut avoir des adhésions avec le même immat
    const immatUniqList = [...new Set(listeAdhesions.map((adh) => adh.immatriculation))];
    const buildImmatList = immatUniqList.map((immat) => ({
      id: immat || '',
      value: immat || '',
    }));
    immatOptionsList = buildImmatList;
    // immatOptionList.push(optionAutreImmat);
  }

  const {
    watch,
    handleSubmit,
    formState: { errors },
    register,
    setValue,
    clearErrors,
    reset,
  } = methods;

  const [paramsContactForm, setParamsContactForm] = useState<ContactFormData | undefined>();
  const [confirmContact, setConfirmContact] = useState<boolean>(false);
  const { response, fetching, error: errorApi } = useFetch<DemandeContact>(
    paramsContactForm,
    'postContact',
    paramsContactForm && paramsContactForm.email ? true : false,
  );

  useEffect(() => {
    if (response) {
      reset();
      setConfirmContact(true);
    }
  }, [response]);
  return {
    methods,
    watch,
    handleSubmit,
    errors,
    register,
    setValue,
    clearErrors,
    setParamsContactForm,
    fetching,
    errorApi,
    setConfirmContact,
    confirmContact,
    immatOptionsList,
    authenticated,
  };
};
